import { Building2, ShieldCheck, ClipboardCheck, FileCheck } from 'lucide-react';
import SpiracleLogo from '../../img/spiracle_logo.png';
import CTA from '../Cta';

function CookingRangeService() {
    return (
        <div className="chimney-repair-container">
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Commercial Pest Control Services</h1>
                    <p className="chimney-repair-subtitle">
                        For restaurants, hotels, offices, malls, warehouses and industries - pests can damage your brand, your products and your reputation. Our commercial pest management keeps your business protected.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We deliver professional and Integrated Pest Management services to commercial premises across Mumbai and the suburbs.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Our treatment regimens are designed according to the type of premise - for kitchens and food outlets, we use only food-safe methods and materials.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We provide documentation, treatment records and service schedules to help you maintain hygiene compliance.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:8530352444")}
                        style={{ cursor: "pointer" }}>
                        Get a Free Inspection
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={SpiracleLogo} alt="Commercial Pest Control" />
            </div>

            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Commercial Service?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Building2 size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Business Protection</h3>
                            <p className="chimney-repair-description">
                                Protects your brand, quality and compliance from pest damage.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ClipboardCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Planned Schedules</h3>
                            <p className="chimney-repair-description">
                                Regular scheduled service visits matched to your business needs.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <FileCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Documentation</h3>
                            <p className="chimney-repair-description">
                                Treatment records and reports for your compliance and audits.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Food Safe Methods</h3>
                            <p className="chimney-repair-description">
                                Safe materials chosen based on the type of premise and outlet.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Commercial Pest Control Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Premise Survey</h3>
                        <p className="chimney-repair-step-description">
                            Full survey of your commercial premise to understand pest pressure and risk areas.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Custom Plan</h3>
                        <p className="chimney-repair-step-description">
                            A tailored pest management plan designed for your type of business.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Treatment</h3>
                        <p className="chimney-repair-step-description">
                            Integrated pest management executed by trained, experienced staff.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Reporting</h3>
                        <p className="chimney-repair-step-description">
                            Treatment reports and follow up visits to ensure long term protection.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default CookingRangeService;